import { useLayoutEffect, useState } from "react";

const useDeviceType = () => {
  const getDevice = () => {
    if (typeof window === "undefined") {
      return { isMobile: false, isTablet: false, isDesktop: true, isLargeDesktop: false };
    }

    const width = window.innerWidth;
    return {
      isMobile: width <= 640, // mobile
      isTablet: width > 640 && width <= 1024, // tablet
      isDesktop: width > 1024, // desktop
      isLargeDesktop: width >= 1600, // large desktop / wide monitor
    };
  };

  const [device, setDevice] = useState(getDevice);

  const checkDevice = () => {
    setDevice(getDevice());
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return device;
};

export default useDeviceType;
